module.exports = __webpack_public_path__ + "img/upload-camera-image.f4d67e40.svg";